import { useMutation } from '@tanstack/react-query'
import { ExtendableMutationOptions } from 'shared/api/api.types'

import { containerApi } from '../..'
import { DeleteWallpaperResponse } from './deleteWallpaper.types'

export const deleteWallpaper = async (id: string) => {
  const response = await containerApi.delete<DeleteWallpaperResponse>(
    `/desktop/wallpapers/${id}`
  )
  return response.data
}

export const useDeleteWallpaperMutation = (
  options?: ExtendableMutationOptions<DeleteWallpaperResponse, string>
) => {
  return useMutation({
    mutationFn: deleteWallpaper,
    ...options
  })
}
